<template>
  <div class="stockli__full-width-container robins-egg-bkgr pa-5">
    <div class="stockli-admin-container">
      <div class="h2">Recent Participants</div>
      <div class="participant-details-box">
        <div class="bold-text lg-text headline-text">Search for participants from the current season, beginning on {{ seasonStart }}:</div>
      
        <v-row class="mt-6 mb-0 mr-0 ml-0" dark>
            <v-text-field v-model="filter" append-icon="mdi-magnify" label="Search by name or demo location" block single-line hide-details />
        </v-row>
        <v-row class="mt-2 mr-0 ml-0" dark>
            <v-checkbox v-model="onlyUnclaimed" label="Only show unclaimed participants" />
        </v-row>
      </div>
      
      <v-data-table
        :items="recents"
        :headers="headers"
        hide-default-footer
        :page.sync="page"
        :items-per-page="10"
        @page-count="pageCount = Math.min($event, 8)"
        disable-sort
        mobile-breakpoint="300"
        :loading="loading"
      >
        <!-- eslint-disable-next-line vue/valid-v-slot -->
        <template v-slot:item.Edit="{ item }">
          <v-btn :to="{ name: 'EditParticipant', params: { id: item.id } }" icon color="primary">
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
        </template>
        <!-- eslint-disable-next-line vue/valid-v-slot -->
        <template v-slot:item.Attendance_Rollup="{ item }">
          <div style="white-space: pre-wrap; line-height: 1.4;">{{ item["Attendance_Rollup"] }}</div>
        </template>
      </v-data-table>
      <div class="pt-2">
        <v-pagination v-model="page" :length="pageCount"></v-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import API from "@/services/api";

export default {
  name: "Participants",
  components: {
  },
  data: () => ({
    recents: [],
    loading: false,
    headers: [
      // { text: "Modified", value: "Modified_Time" },
      { text: "Name", value: "Full_Name" },
      { text: "Attendance", value: "Attendance_Rollup" },
      { text: "Edit", value: "Edit", align: "end" },
    ],
    filterTimeout: undefined,
    filter: "",

    page: 1,
    pageCount: 0,

    seasonStart: undefined,
    onlyUnclaimed: true,
  }),
  mounted() {
    const today = new Date();
    let seasonYear = today.getFullYear();
    // If we're pre-May, season started last year
    if (today.getMonth() < 4) seasonYear--;
    this.seasonStart = seasonYear + "-05-01";
    this.RefreshParticipants();
  },
  methods: {
    async RefreshParticipants() {
      try {
        this.loading = true;
        this.recents = await API.GetParticipants(this.filter, this.onlyUnclaimed);
      } finally {
        this.loading = false;
      }
    },
  },
  watch: {
    filter() {
      // delay / debounce until x ms have passed
      if (this.filterTimeout) clearTimeout(this.filterTimeout);
      this.filterTimeout = setTimeout(() => {
        this.RefreshParticipants();
      }, 500);
    },
    onlyUnclaimed() {
      this.RefreshParticipants();
    },
  },
}
</script>
<style scoped lang="scss">
</style>
